import { useMemo, useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Modal } from "react-bootstrap";
import CommonTable from "../../components/CommonTable/CommonTable";
import PageHeader from "../../components/PageHeader/PageHeader";
import { useNavigate, useLocation } from "react-router-dom";
import moment from "moment";
import { FaEye, FaTimes } from "react-icons/fa";
import { get, post } from "../../Services/ApiHandler";
import { URLS } from "../../Services/Constant";
import {
  setDeliveryPartnerData,
  clearDeliveryPartnerData,
} from "../redux/slice/deliveryPartnerView";

const DeliveryPartnerView = () => {
  const [activeTab, setActiveTab] = useState("ongoing");
  const tabRef = useRef(1);
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const storedPartnerData = useSelector((state) => state?.deliveryPartnerView);
  const statePage = location?.state?.page;
  const selectedTab = location?.state?.tab;
  const routeViewData = location?.state?.viewData;
  const page = statePage || 1;
  const routePartnerId =
    location?.state?.id || location?.state?.data?.id || null;
  const id = routePartnerId || storedPartnerData?.deliveryPartnerId || null;
  const viewData = routeViewData || storedPartnerData?.viewData || null;
  const [showFssaiModal, setShowFssaiModal] = useState(false);

  const [data, setData] = useState(null);

  console.log("data-=====>", data);

  const userData = useMemo(
    () => ({
      name: data?.name || "",
      created_at: data?.register_date || "",
      mob_no: data?.mobile_no || "",
      avg_rating: data?.ratings || 0,
      email: data?.email || "",
      profile_img_url: data?.profile_image || "",
      fssai_certificate_url: data?.fssai_certificate_url || "",
      overall_earnings: data?.overall_earnings || 0,
      user_type: data?.user_type || "-",
      wallet_balance: data?.wallet_balance || 0,
    }),
    [data],
  );

  const [bookingData, setBookingData] = useState([]);
  const [sellingData, setSellingData] = useState([]);
  const [walletData, setWalletData] = useState([]);

  //Table states
  const [pageNo, setPageNo] = useState(1);
  const [totalCount, setTotalCount] = useState();
  const [pagination, setPagination] = useState(null);
  const [searchText, setSearchText] = useState("");
  const pageRef = useRef(pageNo);
  const preSearchPageRef = useRef(pageNo);

  const handleView = () => {};

  const columnsTwo = useMemo(
    () => [
      {
        Header: "S.No",
        accessor: (row, index) => String((index || 0) + 1).padStart(2, "0"),
        width: "5%",
      },
      {
        Header: "Type",
        accessor: "type",
        Cell: ({ value }) => value || "N/A",
      },
      {
        Header: "Amount",
        accessor: "amount",
        Cell: ({ value }) => value || "N/A",
      },
      {
        Header: "Previous Balance (₹)",
        accessor: "previous_balance",
        Cell: ({ value }) => value || "N/A",
      },
      {
        Header: "New Balance (₹)",
        accessor: "new_balance",
        Cell: ({ value }) => value || 0,
      },
      ...(activeTab !== "wallet"
        ? [
            {
              Header: "Action",
              accessor: "action",
              disableSortBy: true,
              width: "10%",
              Cell: ({ row }) => (
                <button
                  className="action-btn d-flex ac-jc"
                  onClick={() =>
                    navigate("/delivery-partner-order-view", {
                      state: {
                        id: row?.original?.id,
                        partnerId: id,
                        tab: tabRef.current,
                        page: page,
                        data: row?.original,
                      },
                    })
                  }
                >
                  <FaEye />
                </button>
              ),
            },
          ]
        : []),
    ],
    [id, page, activeTab],
  );

  const columns = useMemo(() => {
    let d = [
      {
        Header: "Order_Id",
        accessor: "order_id",
        Cell: ({ value }) => value || "N/A",
      },
      {
        Header: "Pickup Location",
        accessor: "pickup_location",
        Cell: ({ value }) => (
          <div
            style={{
              maxWidth: "200px",
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
            title={value || "N/A"}
          >
            {value || "N/A"}
          </div>
        ),
      },
      {
        Header: "Drop Location",
        accessor: "drop_location",
        Cell: ({ value }) => (
          <div
            style={{
              maxWidth: "200px",
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
            title={value || "N/A"}
          >
            {value || "N/A"}
          </div>
        ),
      },
      {
        Header: "Amount",
        accessor: "amount",
        Cell: ({ value }) => `₹ ${value}` || 0,
      },
    ];

    let action = {
      Header: "Action",
      accessor: "action",
      disableSortBy: true,
      width: "20%",
      Cell: ({ row }) => {
        return (
          <>
            {/* {permission?.includes("CAN-VIEW-ORDERS_MANAGEMENT") && ( */}
            <button
              className="action-btn d-flex ac-jc"
              onClick={() => handleView(row?.original)}
            >
              <FaEye />
            </button>
            {/* )} */}
          </>
        );
      },
    };

    return [...d, action];
  }, [page]);

  console.log("dataUserDetails", data);
  console.log(
    "22-data-=====>",
    data,
    page,
    pageNo,
    location?.state?.page,
    preSearchPageRef.current,
  );

  useEffect(() => {
    if (routePartnerId || routeViewData) {
      dispatch(
        setDeliveryPartnerData({
          id: routePartnerId,
          viewData: routeViewData,
        }),
      );
    }
  }, [dispatch, routePartnerId, routeViewData]);

  useEffect(() => {
    const fetchUserDetails = async () => {
      if (!id) return;
      try {
        const res = await get(
          `${URLS.DELIVERYPARTNER}${id}/?context=${viewData}`,
        );
        console.log("User BYID res:", res);
        if (res?.status === "success") {
          setData(res?.data);
        }
      } catch (error) {
        console.error("Error fetching user details:", error);
      }
    };

    fetchUserDetails();
  }, [id, viewData]);

  useEffect(() => {
    return () => {
      if (location.pathname !== "/delivery-partner-view") {
        dispatch(clearDeliveryPartnerData());
      }
    };
  }, [dispatch, location.pathname]);

  const fetchData = async () => {
    let res;
    if (activeTab === "wallet") {
      res = await get(
        `${URLS.GETDELIVERYPARTNERWALLET}${id}/?page=${pageNo}&search=${searchText}`,
      );
    } else {
      res = await get(
        `${URLS.GETDELIVERYPARTNERTABLE}${id}/?tab=${activeTab}&page=${pageNo}&search=${searchText}`,
      );
    }
    if (res?.status == "success") {
      setTotalCount(res?.count || 0);
      if (activeTab === "wallet") {
        setWalletData(res?.results || []);
      } else {
        setBookingData(res?.results || []);
      }
      setPagination({
        current_page: res?.current_page || 1,
        last_page: res?.total_pages || 1,
      });
    }
  };

  useEffect(() => {
    pageRef.current = pageNo;
  }, [pageNo]);

  useEffect(() => {
    if (location?.state?.page) {
      // clear state after using it
      navigate(location.pathname, {
        replace: true,
        state: {
          page: page,
        },
      });
    }
  }, []);

  useEffect(() => {
    fetchData();
  }, [pageNo, searchText, activeTab]);

  const handleClearSearch = () => {
    setSearchText("");
    setPageNo(preSearchPageRef.current || 1);
  };

  return (
    <div className="user-details-container">
      <PageHeader
        title="Delivery Partner"
        showBackButton={true}
        onBackClick={() =>
          navigate("/delivery-partner", { state: { page: page || 1 } })
        }
      />

      <div className="profile-header-card">
        <div className="profile-image-wrapper">
          <img
            src={
              userData?.profile_img_url ||
              "https://images.unsplash.com/photo-1539571696357-5a69c17a67c6?q=80&w=1887&auto=format&fit=crop"
            }
            alt="Profile"
          />
        </div>
        <div className="profile-info-main">
          <h2>{userData?.name || "N/A"}</h2>
          <div
            onClick={() =>
              navigate("/driver-document", {
                state: {
                  id: id,
                  tab: tabRef.current,
                  page: page,
                },
              })
            }
          >
            <p>
              <span>Driver Document</span>
            </p>
          </div>
        </div>
        <div className="profile-divider"></div>
        <div className="profile-details-grid">
          <div className="detail-item">
            <span className="detail-label">Register Date :</span>
            <span className="detail-value">
              {userData?.created_at
                ? new Date(userData.created_at).toLocaleDateString("en-GB")
                : "N/A"}
            </span>
          </div>
          {/* <div className="detail-item">
            <span className="detail-label">Email ID :</span>
            <span className="detail-value email">
              {userData?.email || "N/A"}
            </span>
          </div> */}
          <div className="detail-item">
            <span className="detail-label">Ratings :</span>
            <span className="detail-value">{userData?.avg_rating || 0}</span>
          </div>
          <div className="detail-item">
            <span className="detail-label">Mobile No :</span>
            <span className="detail-value">
              {userData?.mob_no ? `+91-${userData?.mob_no}` : "N/A"}
            </span>
          </div>
        </div>
      </div>
      <div className="profile-header-card">
        <div className="profile-info-main">
          <h2>Wallet Amount</h2>
          <p style={{ color: "#333333" }}>₹{userData?.wallet_balance}</p>
        </div>
        <div className="profile-divider" />
        <input
          type="number"
          name="adminName"
          // value={formData.adminName || ""}
          // onChange={handleChange}
          className="useraddwallet"
          placeholder="Enter Amount"
          required
          // disabled={isViewMode}
        />
        <div className="profile-divider" />
        <div
          className="form-groups"
          style={{
            display: "flex",
            gap: 15,
            alignItems: "flex-end",
          }}
        >
          <button type="submit" className="btn-save">
            Add
          </button>

          <button type="button" className="btn-edit">
            Remove
          </button>
        </div>
      </div>
      <div className="user-details-tabs">
        <button
          className={`tab-btn ${
            activeTab === "ongoing" ? "active" : "inactive"
          }`}
          onClick={() => {
            setBookingData([]);
            setActiveTab("ongoing");
            tabRef.current = 1;
          }}
        >
          Ongoing Order
        </button>
        <button
          className={`tab-btn ${
            activeTab === "completed" ? "active" : "inactive"
          }`}
          onClick={() => {
            setBookingData([]);
            setActiveTab("completed");
            tabRef.current = 2;
          }}
        >
          Completed
        </button>

        <button
          className={`tab-btn ${
            activeTab === "cancel" ? "active" : "inactive"
          }`}
          onClick={() => {
            setBookingData([]);
            setActiveTab("cancel");
            tabRef.current = 3;
          }}
        >
          Cancel
        </button>
        <button
          className={`tab-btn ${
            activeTab === "wallet" ? "active" : "inactive"
          }`}
          onClick={() => {
            setBookingData([]);
            setActiveTab("wallet");
            tabRef.current = 4;
          }}
        >
          Wallet
        </button>
      </div>

      <div className="header-row">
        <h2 className="total-count">Total: {totalCount || 0}</h2>

        <div className="search-wrapper">
          <input
            type="text"
            placeholder="Search"
            className="search-input"
            value={searchText || ""}
            onChange={(e) => {
              const val = e.target.value;

              if (!searchText && val) {
                preSearchPageRef.current = pageNo || 1;
                setPageNo(1);
              } else if (searchText && !val) {
                setPageNo(preSearchPageRef.current || 1);
              }

              setSearchText(val);
            }}
          />
          {searchText && (
            <FaTimes
              className="search-clear-icon"
              onClick={handleClearSearch}
            />
          )}
        </div>
      </div>

      <div className="table-section">
        <CommonTable
          columns={activeTab === "wallet" ? columnsTwo : columns}
          data={(activeTab === "wallet" ? walletData : bookingData) || []}
          pagecount={pagination}
          pageno={pageNo}
          setPageno={setPageNo}
        />
      </div>

      {/* FSSAI Certificate Modal */}
      <Modal
        show={showFssaiModal}
        onHide={() => setShowFssaiModal(false)}
        centered
        size="lg"
      >
        <Modal.Header
          closeButton
          className="d-flex justify-content-between align-items-center"
        >
          <Modal.Title style={{ color: "#7a52ab", fontWeight: "600" }}>
            FSSAI Certificate
          </Modal.Title>
          {/* {userData?.fssai_certificate_url && (
            <button
              onClick={handleDownload}
              className="btn-download"
              style={{
                marginRight: "40px",
                background: "none",
                border: "none",
                color: "#7a52ab",
                fontSize: "20px",
                cursor: "pointer",
              }}
              title="Download Certificate"
            >
              <FaDownload />
            </button>
          )} */}
        </Modal.Header>
        <Modal.Body className="text-center p-0" style={{ height: "80vh" }}>
          {userData?.fssai_certificate_url ? (
            userData.fssai_certificate_url.toLowerCase().endsWith(".pdf") ? (
              <iframe
                src={`${userData.fssai_certificate_url}#toolbar=0`}
                title="FSSAI Certificate PDF"
                width="100%"
                height="100%"
                style={{ border: "none", borderRadius: "0 0 8px 8px" }}
              />
            ) : (
              <div className="p-4">
                <img
                  src={userData.fssai_certificate_url}
                  alt="FSSAI Certificate"
                  style={{
                    maxWidth: "100%",
                    maxHeight: "70vh",
                    borderRadius: "8px",
                    boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
                  }}
                />
              </div>
            )
          ) : (
            <div className="p-4">
              <p>No certificate available</p>
            </div>
          )}
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default DeliveryPartnerView;
